import { formatUkDateFromString } from '../utils/stringUtils';
import { backendFetch } from './apiUtils';

export const getUnmatchedDeclarations = async (filter = {}, skip, amount, tableSort) => {
  const sort = {};
  if (tableSort?.direction) {
    sort.sortColumn = tableSort.currentKey;
    sort.sortDirection = tableSort.direction;
  }

  const response = await backendFetch({
    url: 'unmatchedDecs/lazyLoad',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filter, skip, amount, ...sort }),
    },
  });

  const formattedData = response.data.map((declaration) => {
    return { createdOn: formatUkDateFromString(declaration['Declarations Date']), ...declaration };
  });

  return { totalItems: response.totalItems, data: formattedData };
};

//statuses in the UnmatchedDeclarations lazy screen
export const getUnmatchedDeclarationsLazyStatuses = async () => {
  return await backendFetch({
    url: 'unmatchedDecs/lazyStatusList',
  });
};

export const getDeclarationData = async (declarationResponseLogId, isMatchedDeclaration = false) => {
  const url = isMatchedDeclaration ? 'matchedDecs/actionDetails' : 'unmatchedDecs/actionDetails';

  try {
    const response = await backendFetch({
      url,
      method: 'POST',
      options: {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ declarationResponseLogId }),
      },
    });

    return response.map(({ declarationsDate, ...rest }) => {
      return { declarationsDate: formatUkDateFromString(declarationsDate), ...rest };
    });
  } catch (error) {
    console.error('Error in getDeclarationData:', error);
    throw error;
  }
};

export const getDeclarationAuditLogs = async (declarationResponseLogId) => {
  try {
    return await backendFetch({
      url: `declarationAuditLogs`,
      params: { declarationResponseLogId },
    });
  } catch (error) {
    console.error('Error in getDeclarationAuditLogs:', error);
    throw error;
  }
};

export const linkDeclaration = async (id, cabieReference, declarationNumber) => {
  try {
    return await backendFetch({
      url: `unmatchedDecs/declarationLink`,
      method: 'POST',
      options: {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id,
          cabieReference,
          declarationNumber,
        }),
      },
    });
  } catch (error) {
    console.error('Error in linkDeclaration:', error);
    throw error;
  }
};

export const unlinkDeclaration = async (id) => {
  try {
    return await backendFetch({
      url: `matchedDecs/declarationLink`,
      method: 'PUT',
      options: {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      },
    });
  } catch (error) {
    console.error('Error in unlinkDeclaration:', error);
    throw error;
  }
};

export const getUnmatchedDeclarationsLinkOptions = async () => {
  try {
    return await backendFetch({ url: 'unmatchedDecs/declarationTypes' });
  } catch (error) {
    console.error('Error in getUnmatchedDeclarationsLinkOptions:', error);
    throw error;
  }
};

//statuses in the DeclarationsActions screen
export const getUnmatchedDeclarationsStatusOptions = async () => {
  try {
    return await backendFetch({ url: 'unmatchedDecs/statusList' });
  } catch (error) {
    console.error('Error in getUnmatchedDeclarationsStatusOptions:', error);
    throw error;
  }
};

export const getMatchedDeclarationsStatusOptions = async () => {
  try {
    return await backendFetch({ url: 'matchedDecs/statusList' });
  } catch (error) {
    console.error('Error in getMatchedDeclarationsStatusOptions:', error);
    throw error;
  }
};

export const setUnmatchedDeclarationStatus = async (declarationResponseLogId, statusNumber, connectTicketReference) => {
  try {
    return await backendFetch({
      url: 'unmatchedDecs/status',
      method: 'PUT',
      options: {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ declarationResponseLogId, statusNumber, connectTicketReference }),
      },
    });
  } catch (error) {
    console.error('Error in setUnmatchedDeclarationStatus:', error);
    throw error;
  }
};

export const setMatchedDeclarationStatus = async (declarationResponseLogId, statusNumber, connectTicketReference) => {
  try {
    return await backendFetch({
      url: 'matchedDecs/status',
      method: 'PUT',
      options: {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ declarationResponseLogId, statusNumber, connectTicketReference }),
      },
    });
  } catch (error) {
    console.error('Error in setMatchedDeclarationStatus:', error);
    throw error;
  }
};
